(function () {
    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        utils(
            module.exports
        );

    } else {
        utils(
            RivalIQ.module('utils.text')
        );
    }

    function utils(exports) {

        exports.abbreviate = function (text) {
            return text.replace(/\w+/g, function (token) {
                switch (token) {
                    case 'Channel':
                        return 'Ch.';
                    case 'Facebook':
                        return 'FB';
                    case 'Twitter':
                        return 'TW';
                    case 'Google':
                        return 'G';
                    case 'YouTube':
                        return 'YT';
                    case 'Instagram':
                        return 'IG';
                    case 'LinkedIn':
                        return 'LI';
                    case 'Impressions':
                        return 'Imp.';
                    case 'Unspecified':
                        return 'Unsp.';
                    case 'Consumptions':
                        return 'Cons.';
                    case 'Unique':
                        return 'Uniq.';
                    case 'Engagement':
                        return 'Eng.';
                    case 'Impression':
                        return 'Imp.';
                    case 'Accounting':
                        return 'Accnt';
                    case 'Administrative':
                        return 'Admin.';
                    case 'Business':
                        return 'Buis.';
                    case 'Development':
                        return 'Dev.';
                    case 'Community':
                        return 'Comm.';
                    case 'Consulting':
                        return 'Consul.';
                    case 'Education':
                        return 'Edu.';
                    case 'Engineering':
                        return 'Eng.';
                    case 'Entrepreneurship':
                        return 'Entr.';
                    case 'Healthcare':
                        return 'Health.';
                    case 'Organic':
                        return 'Org.';
                    case 'Services':
                        return 'Serv.';
                    case 'Resources':
                        return 'Res.';
                    case 'Information':
                        return 'Info.';
                    case 'Technology':
                        return 'Tech.';
                    case 'Marketing':
                        return 'Market.';
                    case 'Communications':
                        return 'Comm.';
                    case 'Military':
                        return 'Mil.';
                    case 'Protective':
                        return 'Protect.';
                    case 'Operations':
                        return 'Ops.';
                    case 'Management':
                        return 'Mgmt.';
                    case 'Purchasing':
                        return 'Purch.';
                    case 'Research':
                        return 'Rsch.';
                    default:
                        return token;
                }
            });
        };
    }
})();
